import { render, staticRenderFns } from "./CopyTextTitle.vue?vue&type=template&id=e19f3da6&"
import script from "./CopyTextTitle.vue?vue&type=script&lang=js&"
export * from "./CopyTextTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports